export default {
  methods: {
    roleShouldHaveExtendedSession(role){
      // sesion extendida solo disponible para proveedores/agentes
      return role === "supplier" || role === "supplier_agent" || role === "program_executive_manager" || role === "program_commercial_manager";
    }
  }
}